// Typed client for the ED document assistant's routes
// (backend/routes/emergency/documents.js). Drafting itself goes through the
// shared features/ai-assist/streamGeneration.ts with `er_encounter_id`.
import { api } from '@/lib/api/client';
import type { StoredMessage } from './edDocs';

export interface EdDocumentRow {
  id: number;
  doc_type: string;
  approved_by: string | null;
  approved_at: string;
  generation_source: 'ai' | 'manual' | 'template' | null;
  /** The filed .docx in Patient Records; null if storing it failed. */
  document_id: number | null;
}

export interface EdDocumentsResponse {
  encounter_id: number;
  patient: { id: number; uhid: string; name: string };
  doc_types: Array<{ key: string; title: string }>;
  documents: EdDocumentRow[];
  messages: Array<StoredMessage & { id: number; created_at: string }>;
}

export interface ApprovedEdDocument extends EdDocumentRow {
  uhid: string;
  warning?: string;
}

const base = (id: number) => `/emergency/encounters/${id}/documents`;

export const fetchEdDocuments = (encounterId: number) => api.get<EdDocumentsResponse>(base(encounterId));

export const postEdMessage = (encounterId: number, body: { role: 'user' | 'assistant'; content: string; doc_type?: string | null; provider?: string }) =>
  api.post<StoredMessage>(`${base(encounterId)}/messages`, body);

export const approveEdDocument = (encounterId: number, body: {
  doc_type: string; final_doc: string; ai_draft: string | null; generation_source: 'ai' | 'manual';
}) => api.post<ApprovedEdDocument>(base(encounterId), body);
